import { Provider } from '@angular/core';
import { AuthConfig, provideAuth0 } from '@auth0/auth0-angular';
import { environment } from 'src/environments/environment';
import { crmServiceUrl, backendServiceUrl, dimAdminApiUrl, pdObserverUrl } from 'config';
import { internalRequestHttpInterceptorProvider } from '../interceptors';
import { locationServiceEndpoint } from 'app/order-management/config/sdks/locations-service.config';

const auth0Config = environment.auth0 as AuthConfig;

export const authProviders = [
    internalRequestHttpInterceptorProvider,
    provideAuth0({
        ...auth0Config,
        // TODO: Remove default values when all environments have the correct values
        domain: environment.auth0.domain || 'auth.development.fashion.cloud',
        clientId: environment.auth0.clientId || 'MIlL6jCg7WsyR7VdnuFWFCrjYr1KmltL',
        authorizationParams: {
            ...auth0Config.authorizationParams,
            audience: auth0Config.authorizationParams?.audience || 'https://development-backend.fashion.cloud/',
            redirect_uri: window.location.origin,
            redirection_path: window.location.href.replace(window.location.origin, '')
        },
        cacheLocation: 'localstorage',
        useRefreshTokens: true,
        useRefreshTokensFallback: false,
        httpInterceptor: {
            allowedList: [
                {
                    uri: `${crmServiceUrl}/*`,
                    allowAnonymous: true
                },
                {
                    uri: `${locationServiceEndpoint}/*`,
                    allowAnonymous: true
                },
                {
                    uri: `${dimAdminApiUrl}/*`,
                    allowAnonymous: true
                },
                {
                    uri: `${pdObserverUrl}/*`,
                    allowAnonymous: true
                },
                {
                    uri: `${backendServiceUrl}/internal/translations/*`,
                    allowAnonymous: true
                },
                {
                    uri: `${backendServiceUrl}/internal/invitations/*`,
                    httpMethod: 'GET',
                    allowAnonymous: true
                },
                {
                    // Add a token for anything that contains `/${restEndpoint}/internal`, but does not contain /referral or /signup
                    uriMatcher: (uri) =>
                        uri.indexOf(`${backendServiceUrl}/internal`) > -1 &&
                        uri.indexOf('referral') === -1 &&
                        uri.indexOf('signup') === -1
                },
                {
                    // Add a token for anything that contains `/${restEndpoint}/internal` and contains /referral/v2
                    uriMatcher: (uri) =>
                        uri.indexOf(`${backendServiceUrl}/internal`) > -1 && uri.indexOf('referral/v2') > -1
                }
            ]
        }
    })
] as Provider[];
